import { Link } from 'react-router-dom';

type Props = {
  to: string;
  label?: string;
}

export const EditButton = ({ to, label } : Props) => (
  <Link to={to} className="btn">
    <i className="fas fa-edit fa-1x"/>
    <span className="hidden md:flex pl-0.5">
      { label || 'Modifier'}
    </span>
  </Link>
);
